
import { MaterialType } from '../models/materialType';

export interface IMaterialTypeService {
    getMaterialTypes(): Promise<Array<MaterialType>>;
}

export class MaterialTypeService implements IMaterialTypeService {
    static $inject = ['$http'];

    constructor(private _$http: angular.IHttpService) {

    }

    getMaterialTypes(): Promise<any> {

        return new Promise<MaterialType[]>((resolve, reject) => {
            this._$http.get('/getMaterialTypes')
                .then((response: angular.IHttpPromiseCallbackArg<any>) => {
                   
                    const materialTypes = response.data.map(s => new MaterialType(s.materialTypeId, s.description, s.description2));
                    resolve(materialTypes);
                });
        });
    }


}

angular.module('deliveryCreate.app').service('materialTypeService', MaterialTypeService);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/materialDialog/services/materialTypeService.ts
 **/